import {Link} from '@mui/material';
import {ProviderContext as SnackbarContext, useSnackbar} from 'notistack';
import React from 'react';

import {Formatters, useFormatters} from './light';
import {ValuesToCopy} from './navigation';

type CopyToClipboardMessages = {
  successMessage?: string;
  notSupportedMessage?: string;
};
export async function copyToClipboard(
  text: string,
  snackBar: SnackbarContext,
  formatters: Formatters,
  messages: CopyToClipboardMessages = {}
) {
  const {t} = formatters;
  const {successMessage = 'global.copyToClipboardSnack', notSupportedMessage = 'global.copyToClipboardErrorSnack'} = messages;
  if (navigator.clipboard) {
    await navigator.clipboard.writeText(text);
    snackBar.enqueueSnackbar(t(successMessage));
  } else {
    snackBar.enqueueSnackbar(t(notSupportedMessage), {variant: 'error'});
  }
}

type Props = {valuesToCopy: ValuesToCopy; isNavigationOpen: boolean};
export const ValuesToCopyComponent: React.FC<Props> = (props) => {
  const {valuesToCopy, isNavigationOpen} = props;
  const snackBar = useSnackbar();
  const formatters = useFormatters();
  const {t} = formatters;
  /* eslint-disable jsx-a11y/anchor-is-valid */
  // REFACTOR: use copyIcon.svg instead
  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        padding: '8px 12px',
      }}
    >
      <Link
        style={{
          color: 'var(--dlStatusBoxMessage)',
          fontSize: 12,
          cursor: 'pointer',
        }}
        onClick={async () =>
          copyToClipboard(JSON.stringify(valuesToCopy ?? {}), snackBar, formatters, {
            successMessage: 'hospitalization.detail.copyIdValuesSnack',
            notSupportedMessage: 'hospitalization.detail.copyIdValuesErrorSnack',
          })
        }
      >
        {isNavigationOpen && t('hospitalization.detail.copyIdValues')}
        <svg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg' style={{marginLeft: '8px'}}>
          <g clipPath='url(#clip0_1166_12760)'>
            <path
              d='M10.5 9H6C5.17266 9 4.5 8.32734 4.5 7.5V1.5C4.5 0.672656 5.17266 0 6 0H9.28359C9.58125 0 9.86719 0.119531 10.0781 0.330469L11.6695 1.92188C11.8805 2.13281 12 2.41875 12 2.71641V7.5C12 8.32734 11.3273 9 10.5 9ZM1.5 3H3.75V4.125H1.5C1.29375 4.125 1.125 4.29375 1.125 4.5V10.5C1.125 10.7063 1.29375 10.875 1.5 10.875H6C6.20625 10.875 6.375 10.7063 6.375 10.5V9.75H7.5V10.5C7.5 11.3273 6.82734 12 6 12H1.5C0.672656 12 0 11.3273 0 10.5V4.5C0 3.67266 0.672656 3 1.5 3Z'
              fill='#eee' // NOTE: we use a less strong white, because the icon is filled in
            />
          </g>
          <defs>
            <clipPath id='clip0_1166_12760'>
              <rect width='12' height='12' fill='white' />
            </clipPath>
          </defs>
        </svg>
      </Link>
    </div>
  );
};
